@if(loading()) {
<div class="cc4">
    <h2>Alternative Angebote, die deinen Wünschen am nächsten kommen.</h2>
    <div class="cc5">
        <div class="cc6">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
    </div>
</div>
} @else {
@if(hotels?.length > 0) {
<mat-divider></mat-divider>
<div class="cc1">
    <span class="cc2">Alternative Angebote, die deinen
        Wünschen am nächsten kommen.</span>
    <div class="cc3" [style.flex-direction]="desktopTemplate !== 'xs' && desktopTemplate !== 'sm' ? 'row' : 'column'">
        @for (hotel of hotels; track $index) {
        <app-recommendationcard [hotel]="hotel" [giataIdG]="data?.giataId" [tmp_realparams]="realparams"
            class="w100"></app-recommendationcard>
        }
    </div>
</div>
}
}
